


<div class="form-row">
    <slot />
</div>

<style>
    .form-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        column-gap: 10px;
        font-size: var(--font-size-tactical-plan);
    }
</style>